import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React from 'react'

// Date (left) + timestamp (right) burned over a full-width bottom scrim so they stay
// legible on bright photos; the swiper pagination dots sit centered on the same strip.
const ExceptionCardBottomOverlay = ({ date = '', time = '', ...rest }) => (
  <Box
    alignItems="center"
    bottom={0}
    display="flex"
    justifyContent="space-between"
    left={0}
    position="absolute"
    px={1.5}
    py={0.75}
    right={0}
    sx={{ background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.65))' }}
    {...rest}
  >
    <Typography color="common.white" variant="caption">
      {date}
    </Typography>
    <Typography color="common.white" variant="caption">
      {time}
    </Typography>
  </Box>
)

ExceptionCardBottomOverlay.propTypes = {
  date: PropTypes.string,
  time: PropTypes.string,
}

export default ExceptionCardBottomOverlay
